import { isValidCurrencyCode } from "#utils/currency";
import { isSupportedLocale } from "#utils/locale";
import { z } from "zod";
/**
 * Factory function to create CreateUserValidator with translations
 */
export const createCreateUserValidator = (t) => z.object({
    email: z.email(t("validation.email")),
    password: z.string().min(8, t("validation.users.passwordMinLength")),
});
/**
 * Factory function to create ResendVerificationEmailValidator with translations
 */
export const createResendVerificationEmailValidator = (t) => z.object({
    email: z.string().email(t("validation.email")),
});
/**
 * Factory function to create UpdateUserLocaleValidator with translations
 */
export const createUpdateUserLocaleValidator = (t) => z.object({
    locale: z
        .string()
        .refine((val) => isSupportedLocale(val), t("validation.users.invalidLocale") || "Invalid locale. Must be a supported locale code."),
});
/**
 * Factory function to create UpdateUserPreferencesValidator with translations
 */
export const createUpdateUserPreferencesValidator = (t) => z
    .object({
    preferences: z
        .object({
        currency: z
            .string()
            .refine((val) => isValidCurrencyCode(val), t("validation.users.invalidCurrency") || "Invalid currency code")
            .optional(),
    })
        .passthrough(), // Allow other preference fields
})
    .strict();
